import axios from "axios";
import { AUTH_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { AuthConfig } from "../../../context/config/authConfig";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IGetMyInfoRepose, IUpdateProfileInfoRequestBody } from "./models";

const appProvide = async () => AuthConfig.getAppToken();
const defaultProvide = async () => await getToken();

export const updateProfileInfo = (
  id: string,
  body: IUpdateProfileInfoRequestBody
): Promise<IGetMyInfoRepose> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/profiles/${id}/personal`,
    "PATCH",
    appProvide
  );
  return fetchRequest(descriptor, body);
};

export const getMyInfo = (): Promise<IGetMyInfoRepose> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/profiles/me`,
    "GET",
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getUserInfo = async (
  userToken: string
): Promise<{ data: IGetMyInfoRepose }> => {
  const config = {
    headers: {
      authorization: `Bearer ${userToken}`,
      "Content-Type": "application/json",
    },
  };

  // eslint-disable-next-line no-useless-catch
  try {
    const response: { data: IGetMyInfoRepose } = await axios.get(
      `${AUTH_BASE_URL}/api/profiles/me`,
      config
    );
    return response;
  } catch (error) {
    throw error;
  }
};
